import axios from "axios";

export const generateToken = async (baseUrl, username, password) => {
  try {
    const params = new URLSearchParams();

    params.append("username", username);
    params.append("password", password);

    const finalBaseUrl = baseUrl.startsWith("http")
      ? baseUrl
      : `https://${baseUrl}`;

    console.log("TOKEN API URL :", `${finalBaseUrl}/api/generate_token`);

    // API Call
    const response = await axios.post(
      `${finalBaseUrl}/api/generate_token`,
      params,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );

    console.log("TOKEN RESPONSE :", response.data);

    if (!response.data?.access_token) {
      throw new Error("Access token not received");
    }

    return {
      token: response.data.access_token,
      baseUrl: finalBaseUrl,
    };
  } catch (error) {
    console.log("GENERATE TOKEN ERROR :", error);

    return null;
  }
};
